import React, { createContext, useContext, useState } from "react";

import { get, jsonParser, form } from "../api/Client";

const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [isAuth, setIsAuth] = useState(false);
  const [user, setUser] = useState({});

  const testAuth = () =>
    get("/me")
      .then(jsonParser)
      .then((data) => {
        console.debug("Autenticado!");
        setUser(data);
        setIsAuth(true);
      })
      .catch((e) => {
        console.debug("Não Autenticado!");
        setUser({});
        setIsAuth(false);
        return Promise.reject(e);
      });

  const authenticate = (email, password) =>
    form("/authenticate", { body: { username: email, password, role: "ADMIN" } })
      .then((res) => {
        if (res.status !== 200) {
          setIsAuth(false);
          localStorage.apiToken = null;
          return Promise.reject("Usuário ou senha inválidos.");
        } else {
          return res.json();
        }
      })
      .then((data) => {
        localStorage.apiToken = data.token;
        setUser(data.user);
        setIsAuth(true);
        return user;
      });

  const logout = () => {
    localStorage.removeItem("apiToken");
    setUser({});
    setIsAuth(false);
  };

  return (
    <AuthContext.Provider
      value={{ isAuth, user, testAuth, authenticate, logout }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContextProvider;
